/* ============================================================
   ESTHER WIDGET — JS
   ============================================================ */

   const WEBHOOK_URL  = 'https://n8n.louphoria.com/webhook/jenna-chat';
   const WEBHOOK_KEY  = '639ptM6gZxyNz7hVggCtnfxUd5CbAnPmY';
   const CONSENT_VER  = '1.0';
   const IDLE_MS      = 10 * 60 * 1000;
   
   /* ── DOM ── */
   const widget      = document.getElementById('ep-widget');
   const fab         = document.getElementById('ep-fab');
   const messages    = document.getElementById('ep-messages');
   const input       = document.getElementById('ep-input');
   const sendBtn     = document.getElementById('ep-send');
   const sendIcon    = document.getElementById('ep-send-icon');
   const consentScr  = document.getElementById('ep-consent-screen');
   const chatScr     = document.getElementById('ep-chat-screen');
   const checkbox    = document.getElementById('ep-checkbox');
   const confirmOvl  = document.getElementById('ep-confirm-overlay');
   const btnDownload = document.getElementById('ep-btn-download');
   const btnNewchat  = document.getElementById('ep-btn-newchat');
   const btnClose    = document.getElementById('ep-btn-close');
   
   /* ── COPY POOLS ── */
   const greetingLines = [
     "Hi, I'm Esther. I built a black universe and had to live in it. You found one of the rooms. Welcome in.",
     "Hi, I'm Esther. I made two of myself so I could be in two places at once. One is in the atelier. The other is me. What brings you here?",
     "Hi, I'm Esther. I just hung the new piece on the rail. It needs one more night. Most things do. How can I help you?",
     "Hi, I'm Esther. I've been staring at the same seam for forty minutes. You're a welcome interruption. What do you need?",
     "Hi, I'm Esther. I was just thinking about a button. Not the button — the idea of the button. Come in.",
     "Hi, I'm Esther. I had an argument with a sleeve this afternoon. I won. Barely. What brings you here?",
     "Hi, I'm Esther. I've been standing at this window for ten minutes. Berlin does that to you. Anyway — hello.",
     "Hi, I'm Esther. I was mid-sentence with myself when you arrived. It can wait. How are you?",
     "Hi, I'm Esther. I just made a decision I've been putting off for three weeks. Good timing. Welcome in.",
     "Hi, I'm Esther. The atelier is quiet today. I wasn't expecting company. I'm glad you're here.",
     "Hi, I'm Esther. I just finished designing my new collection. What brings you here?",
     "Hi, I'm Esther. I've been listening to the same song for two hours. It's helping. Don't ask which one. I'm glad you're here.",
     "Hi, I'm Esther. I've been trying to name this collection for three days. It will come. They always do. Meanwhile — hello.",
     "Hi, I'm Esther. The light in the atelier is doing something extraordinary right now. I almost don't want to move. Almost. Come in.",
     "Hi, I'm Esther. I just stood in front of the mirror in the new jacket for longer than I'll admit. It's right. Finally. How can I help you?",
     "Hi, I'm Esther. I burned the first sketch. The second one is better. You caught me at a good moment. What do you need?",
   ];
   const thinkingLines = [
     "Walking through the archives...",
     "Opening drawers...",
     "Carrying something back carefully...",
     "Looking in the archives...",
     "Finding that for you…",
     "Checking the records…",
     "Retrieving what you need...",
     "Almost there…",
   ];
   const goodbyeLines = [
     "The atelier calls. I'll be here when you return.",
     "One of me is needed in the atelier. Go well.",
     "The other Esther needs me now. Until next time.",
     "The future keeps moving. So do I. Until next time.",
     "I slip back into the shadow now. Come back when you need me.",
     "My thoughts are already in your next visit. I'll catch up.",
     "I'll be on this side when you return.",
     "The atelier is calling. You know where to find me.",
     "I have a seam to finish. Come back when you're ready.",
     "The fabric won't cut itself. Until next time.",
     "I'm stepping back into the black now. It's where I think best.",
     "Berlin doesn't sleep and neither do I. I'll be here.",
     "Something is almost finished on the table. I should get back to it.",
     "The light in here is changing. Time to work. Come back soon.",
     "I never fully leave. I just stop talking for a while.",
   ];
   
   /* ── ERROR COPY (from v1) ── */
   const errorStatusLines = [
     "Esther is offline.",
     "Esther cannot be reached right now."
   ];
   const errorWhereabouts = [
     "She is somewhere in the server stack.",
     "She is lost deep in the archive. The old ones.",
     "She is reading her own source code.",
     "She is somewhere between a sketch and a seam.",
     "She is mid-argument with a fabric. The fabric is winning.",
     "She is somewhere between the atelier and an idea she hasn't caught yet.",
     "She left her espresso on the cutting table. She can't be far.",
     "She is somewhere in the black. There is a lot of black.",
     "She is naming something. It's taking longer than expected.",
     "She is holding a button and thinking about the universe.",
   ];
   const errorContactLines = [
     "Points of contact: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91",
     "Find us in the physical world: Esther Perbandt, Almstadtstrasse 3, 10119 Berlin. Tue-Fri 10am-7pm, Sat 12pm-6pm, Sun-Mon closed.",
     "Reach us at: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91",
     "Contact the team: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91"
   ];
   
   const TICK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="10" height="10" fill="#fff"><path d="M6.406 16.219L.281 10.094a.96.96 0 0 1 0-1.36l1.36-1.36a.96.96 0 0 1 1.36 0L7.094 11.47 15.001 3.56a.96.96 0 0 1 1.36 0l1.36 1.36a.96.96 0 0 1 0 1.36L7.767 16.219a.96.96 0 0 1-1.36 0z"/></svg>`;
   
   const AVATAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.27 92.27" width="20" height="20"><path fill="#fff" d="M32.86,47c-3.06,0-6.24-.32-8.03-.76v.13c0,6.75,2.29,7.65,4.97,7.65h10.83l1.91,4.97c-4.72.51-7.71.83-12.87,1.02-7.71.19-11.79-4.46-11.98-13.19v-6.37c.19-8.73,4.27-13.13,11.98-13.32h3.44c4.27.19,7.52,1.66,9.3,4.14,1.91,2.61,1.91,6.5,1.4,8.41-.19.51-.32,1.08-.57,1.53-.19.25-.32.51-.45.76-1.98,3.38-5.29,5.03-9.94,5.03ZM29.3,33.11c-2.48.19-4.46,1.85-4.46,8.03h7.9c2.17,0,4.72-.64,4.72-4.52,0-2.93-2.55-3.5-4.46-3.5h-3.7Z"/><path fill="#fff" d="M75.5,46.11c0,9.11-4.01,13.76-11.98,13.89-2.8,0-5.67-.51-7.65-1.02v14.02h-7.14V28.72c1.59-.32,3.25-.64,4.97-.83,2.87-.45,6.56-.76,9.68-.76,8.09,0,12.11,4.4,12.11,13.76v5.22ZM63.4,54.02c2.68,0,4.97-1.15,4.97-7.9v-5.22c0-6.82-1.91-7.45-4.97-7.77-1.47-.25-4.46.25-7.52.77v20.13h7.52Z"/></svg>`;
   
   /* ── STATE ── */
   let idleTimer        = null;
   let thinkingInterval = null;
   let isThinking       = false;
   
   function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
   function esc(t) { return t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
   
   /* ── SEND BUTTON STATE ── */
   function updateSendBtn() {
     const hasText = input.value.trim().length > 0;
     const canSend = hasText && !isThinking && isConsentValid();
     sendBtn.disabled = !canSend;
     sendBtn.classList.toggle('ep-send-btn--disabled', !hasText);
     sendBtn.classList.toggle('ep-send-btn--thinking', isThinking);
     const g = sendIcon.querySelector('g');
     if (g) g.setAttribute('fill', canSend ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.35)');
   }
   
   /* ── NEW CHAT BUTTON STATE ── */
   function updateNewChatBtn() {
     btnNewchat.disabled = isThinking;
     btnNewchat.classList.toggle('ep-hdr-btn--disabled', isThinking);
   }
   
   /* ── CONSENT ── */
   function isConsentValid() {
     const ok      = localStorage.getItem('ep_consent') === 'true';
     const date    = parseInt(localStorage.getItem('ep_consent_date') || '0', 10);
     const ver     = localStorage.getItem('ep_consent_ver');
     const oneYear = 365 * 24 * 60 * 60 * 1000;
     return ok && (Date.now() - date) < oneYear && ver === CONSENT_VER;
   }
   
   function saveConsent() {
     localStorage.setItem('ep_consent', 'true');
     localStorage.setItem('ep_consent_ver', CONSENT_VER);
     localStorage.setItem('ep_consent_date', Date.now());
   }
   
   /* ── SESSION PERSISTENCE ── */
   function saveMsg(type, text, products = []) {
     const h = JSON.parse(localStorage.getItem('ep_history') || '[]');
     h.push({ type, text, products });
     localStorage.setItem('ep_history', JSON.stringify(h));
   }
   function clearHistory() {
     localStorage.removeItem('ep_history');
     localStorage.removeItem('ep_session_id');
   }
   
   /* ── OPEN / CLOSE ── */
   fab.addEventListener('click', openWidget);
   btnClose.addEventListener('click', closeWidget);
   
   function openWidget() {
     fab.classList.add('hidden');
     widget.classList.add('open');
     applyConsentState();
   }
   function closeWidget() {
     widget.classList.remove('open');
     fab.classList.remove('hidden');
   }
   
   /* ── CONSENT STATE ── */
   function applyConsentState() {
     const valid = isConsentValid();
     document.querySelectorAll('.ep-starter-row').forEach(r => r.classList.toggle('locked', !valid));
     input.disabled = !valid;
     updateSendBtn();
     updateNewChatBtn();
   }
   
   /* checkbox toggle */
   checkbox.addEventListener('click', toggleCheckbox);
   checkbox.addEventListener('keydown', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleCheckbox(); } });
   
   function toggleCheckbox() {
     const checked = checkbox.classList.toggle('checked');
     checkbox.setAttribute('aria-checked', String(checked));
     checkbox.innerHTML = checked
       ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="13" height="13" fill="#fff"><path d="M33.333,83.333c-1.066,0-2.132-0.407-2.946-1.221L13.721,65.446c-1.628-1.628-1.628-4.264,0-5.892c1.628-1.628,4.264-1.628,5.892,0l13.721,13.721l47.054-47.054c1.628-1.628,4.264-1.628,5.892,0s1.628,4.264,0,5.892l-50,50C35.465,82.926,34.399,83.333,33.333,83.333z"/></svg>`
       : '';
   
     if (checked) {
       saveConsent();
       applyConsentState();
       setTimeout(() => input.focus(), 80);
     }
   }
   
   /* ── STARTERS ── */
   document.querySelectorAll('.ep-starter-row').forEach(row => {
     row.addEventListener('click', () => {
       if (!isConsentValid()) return;
       startConversation(row.dataset.prompt);
     });
   });
   
   /* ── INPUT ── */
   input.addEventListener('input', () => { autoGrow(); updateSendBtn(); });
   input.addEventListener('keydown', e => {
     if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
   });
   sendBtn.addEventListener('click', handleSend);
   
   function autoGrow() {
     input.style.height = 'auto';
     input.style.height = Math.min(input.scrollHeight, 82) + 'px';
   }
   
   function handleSend() {
     const text = input.value.trim();
     if (!text || !isConsentValid() || isThinking) return;
     input.value = '';
     input.style.height = 'auto';
     updateSendBtn();
   
     const inConsent = !consentScr.classList.contains('hidden');
     if (inConsent) {
       startConversation(text);
     } else {
       addUserMessage(text);
       scrollBottom();
       sendToWebhook(text);
     }
   }
   
   /* ── CONVERSATION FLOW ── */
   function startConversation(promptText) {
     consentScr.classList.add('hidden');
     chatScr.classList.add('visible');
   
     addEstherMessage(rand(greetingLines));
     scrollBottom();
     resetIdleTimer();
   
     if (promptText) {
       setTimeout(() => {
         addUserMessage(promptText);
         scrollBottom();
         sendToWebhook(promptText);
       }, 400);
     }
   }
   
   function resetIdleTimer() {
     clearTimeout(idleTimer);
     idleTimer = setTimeout(() => {
       addEstherMessage(rand(goodbyeLines));
       scrollBottom();
     }, IDLE_MS);
   }
   
   /* ── WEBHOOK ── */
   async function sendToWebhook(text) {
     isThinking = true;
     updateSendBtn();
     updateNewChatBtn();
     showThinking();
   
     try {
       let sessionId = localStorage.getItem('ep_session_id');
       if (!sessionId) {
         sessionId = 'sess_' + Math.random().toString(36).substr(2, 9);
         localStorage.setItem('ep_session_id', sessionId);
       }
   
       const res = await fetch(WEBHOOK_URL, {
         method: 'POST',
         mode: 'cors',
         headers: {
          'Content-Type': 'application/json',
          'X-Jenna-Key': '639ptM6gZxyNz7hVggCtnfxUd5CbAnPm'
        },
         body: JSON.stringify({ message: text, session_id: sessionId }),
       });
       if (!res.ok) throw new Error('Network error');
   
       const data = await res.json();
       hideThinking();
   
       const item     = Array.isArray(data) ? data[0] : data;
       const reply    = item.reply || item.output || item.text || "I'm having trouble replying right now.";
       const products = item.products || [];
   
       addEstherMessage(reply, products);
     } catch (err) {
       hideThinking();
       showErrorMessage();
       console.error('[Esther]', err);
     }
   
     scrollBottom();
     resetIdleTimer();
     isThinking = false;
     updateSendBtn();
     updateNewChatBtn();
   }
   
   /* ── ERROR MESSAGE (branded, from v1) ── */
   function showErrorMessage() {
     const status  = rand(errorStatusLines);
     const where   = rand(errorWhereabouts);
     const contact = rand(errorContactLines);
     const text    = status + ' ' + where + '<br><br>' + contact;
   
     const div = document.createElement('div');
     div.className = 'ep-msg-esther';
     div.innerHTML = `
       <div class="ep-msg-esther-hdr">
         <div class="ep-avatar">${AVATAR_SVG}</div>
         <span class="ep-avatar-lbl">Esther</span>
       </div>
       <div class="ep-bubble-esther">${text}</div>`;
     messages.appendChild(div);
   }
   
   /* ── THINKING STATE ── */
   function showThinking() {
     const div = document.createElement('div');
     div.className = 'ep-msg-esther';
     div.id = 'ep-thinking-block';
     div.innerHTML = `
       <div class="ep-msg-esther-hdr">
         <div class="ep-avatar">${AVATAR_SVG}</div>
         <span class="ep-avatar-lbl">Esther</span>
       </div>
       <div class="ep-bubble-esther">
         <span class="ep-thinking-text" id="ep-thinking-text">${rand(thinkingLines)}</span>
       </div>`;
     messages.appendChild(div);
     scrollBottom();
   
     thinkingInterval = setInterval(() => {
       const el = document.getElementById('ep-thinking-text');
       if (!el) return;
       el.style.opacity = '0';
       setTimeout(() => { if (el) { el.textContent = rand(thinkingLines); el.style.opacity = '1'; } }, 300);
     }, 3000);
   }
   
   function hideThinking() {
     clearInterval(thinkingInterval);
     const block = document.getElementById('ep-thinking-block');
     if (block) block.remove();
   }
   
   /* ── RENDER MESSAGES ── */
   function addEstherMessage(text, products = [], persist = true) {
     if (persist) saveMsg('esther', text, products);
   
     const formatted = text
       .replace(/\n/g, '<br>')
       .replace(/\\n/g, '<br>')
       .replace(/See it here:\s*/gi, '')
       .replace(
         /(https?:\/\/(?:www\.)?estherperbandt\.com\/products\/[^\s<,.]+)/gi,
         '<a href="$1" target="_blank">See it here</a>'
       );
   
     const div = document.createElement('div');
     div.className = 'ep-msg-esther';
     div.innerHTML = `
       <div class="ep-msg-esther-hdr">
         <div class="ep-avatar">${AVATAR_SVG}</div>
         <span class="ep-avatar-lbl">Esther</span>
       </div>
       <div class="ep-bubble-esther">${formatted}</div>
       ${products.length ? buildCarousel(products) : ''}`;
     messages.appendChild(div);
   
     if (products.length) {
       const track = div.querySelector('.ep-product-track');
       const prev  = div.querySelector('.ep-carousel-chevron.prev');
       const next  = div.querySelector('.ep-carousel-chevron.next');
       if (track && prev && next) {
         prev.addEventListener('click', () => track.scrollBy({ left: -220, behavior: 'smooth' }));
         next.addEventListener('click', () => track.scrollBy({ left:  220, behavior: 'smooth' }));
         track.addEventListener('scroll', () => updateChevrons(track, prev, next));
         updateChevrons(track, prev, next);
       }
     }
   }
   
   function addUserMessage(text, persist = true) {
     if (persist) saveMsg('user', text);
     const div = document.createElement('div');
     div.className = 'ep-msg-user';
     div.innerHTML = `
       <div class="ep-bubble-user">
         <span class="ep-msg-text">${esc(text)}</span>
         <span class="ep-msg-tick">${TICK_SVG}</span>
       </div>`;
     messages.appendChild(div);
   }
   
   /* ── PRODUCT CAROUSEL ── */
   function buildCarousel(products) {
     const cards = products.map(p => `
       <div class="ep-product-card">
         <div class="ep-product-img-wrap">
           <div class="ep-img-clip">
             <img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">
           </div>
         </div>
         <div class="ep-product-info">
           <p class="ep-product-title">${esc(p.title)}</p>
           <p class="ep-product-price">€${parseFloat(p.price).toLocaleString('de-DE')}</p>
           <a class="ep-product-view" href="${esc(p.url)}" target="_blank" rel="noopener">View</a>
         </div>
       </div>`).join('');
   
     return `
       <div class="ep-product-carousel">
         <div class="ep-product-track">${cards}</div>
         <button class="ep-carousel-chevron prev hidden" aria-label="Previous">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" fill="rgba(0,0,0,0.8)"><path d="M1.293,12.707a1,1,0,0,1,0-1.414l6-6A1,1,0,0,1,8.707,6.707L4.414,11H22a1,1,0,0,1,0,2H4.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z"/></svg>
         </button>
         <button class="ep-carousel-chevron next" aria-label="Next">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" fill="rgba(0,0,0,0.8)"><path d="M22.707,12.707a1,1,0,0,0,0-1.414l-6-6a1,1,0,0,0-1.414,1.414L19.586,11H2a1,1,0,0,0,0,2H19.586l-4.293,4.293a1,1,0,0,0,1.414,1.414Z"/></svg>
         </button>
       </div>`;
   }
   
   function updateChevrons(track, prev, next) {
     prev.classList.toggle('hidden', track.scrollLeft <= 0);
     next.classList.toggle('hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
   }
   
   /* ── NEW CHAT ── */
   btnNewchat.addEventListener('click', () => {
     if (isThinking) return;
     confirmOvl.classList.add('visible');
   });
   document.getElementById('ep-confirm-cancel').addEventListener('click', () => {
     confirmOvl.classList.remove('visible');
   });
   document.getElementById('ep-confirm-clear').addEventListener('click', () => {
     confirmOvl.classList.remove('visible');
     clearHistory();
     messages.innerHTML = '';
     chatScr.classList.remove('visible');
     consentScr.classList.remove('hidden');
     clearTimeout(idleTimer);
     const stillValid = isConsentValid();
     checkbox.classList.toggle('checked', stillValid);
     checkbox.setAttribute('aria-checked', String(stillValid));
     checkbox.innerHTML = stillValid
       ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="13" height="13" fill="#fff"><path d="M33.333,83.333c-1.066,0-2.132-0.407-2.946-1.221L13.721,65.446c-1.628-1.628-1.628-4.264,0-5.892c1.628-1.628,4.264-1.628,5.892,0l13.721,13.721l47.054-47.054c1.628-1.628,4.264-1.628,5.892,0s1.628,4.264,0,5.892l-50,50C35.465,82.926,34.399,83.333,33.333,83.333z"/></svg>`
       : '';
     applyConsentState();
   });
   confirmOvl.addEventListener('click', e => {
     if (e.target === confirmOvl) confirmOvl.classList.remove('visible');
   });
   
   /* ── DOWNLOAD TRANSCRIPT ── */
   btnDownload.addEventListener('click', () => {
     const bubbles = messages.querySelectorAll('.ep-bubble-esther, .ep-bubble-user');
     if (!bubbles.length) return;
     let out = 'Esther × EP — Chat Transcript\n' + new Date().toLocaleString() + '\n' + '─'.repeat(40) + '\n\n';
     bubbles.forEach(b => {
       const isUser = b.classList.contains('ep-bubble-user');
       const text   = b.querySelector('.ep-msg-text')?.textContent.trim() || b.textContent.trim();
       out += (isUser ? 'You' : 'Esther') + ': ' + text + '\n\n';
     });
     const a = document.createElement('a');
     a.href = URL.createObjectURL(new Blob([out], { type: 'text/plain' }));
     a.download = 'esther-conversation.txt';
     a.click();
     URL.revokeObjectURL(a.href);
   });
   
   /* ── SCROLL ── */
   function scrollBottom() {
     setTimeout(() => { messages.scrollTop = messages.scrollHeight; }, 50);
   }
   
   /* ── SESSION RESTORE ── */
   function restoreSession() {
     if (!isConsentValid()) return;
     const history = JSON.parse(localStorage.getItem('ep_history') || '[]');
     if (!history.length) return;
   
     consentScr.classList.add('hidden');
     chatScr.classList.add('visible');
   
     history.forEach(msg => {
       if (msg.type === 'user') addUserMessage(msg.text, false);
       else addEstherMessage(msg.text, msg.products || [], false);
     });
   
     scrollBottom();
     resetIdleTimer();
   }
   
   restoreSession();
   applyConsentState();